import {
  ISourceEntityHandler,
  type ISource,
} from '@principle-theorem/practice-migrations/interfaces';
import { BaseSourceHandler } from '../source/base-source-handler';
import { getRequiredCsvFilenames } from '../source/required-csv-files';
import { ADAItemSourceEntity } from './source/entities/ada-item';
import { ADAItemSourceEntity as ExactADASourceEntity } from '../exact/source/entities/ada-item';
import { AppointmentCategorySourceEntity } from '../exact/source/entities/appointment-category';
import { ContactsSourceEntity } from '../exact/source/entities/contacts';
import { FeeScheduleSourceEntity } from '../exact/source/entities/fee-schedule';
import { PatientSourceEntity } from './source/entities/patients';
import { AppointmentSourceEntity } from '../exact/source/entities/patient-appointment';
import { PatientBalanceSourceEntity } from '../exact/source/entities/patient-balance';
import { PatientDocumentsSourceEntity } from '../exact/source/entities/patient-documents';
import { PatientExternalLinksSourceEntity } from '../exact/source/entities/patient-external-links';
import { PatientNotesSourceEntity } from '../exact/source/entities/patient-notes';
import { PatientPerioExamsSourceEntity } from '../exact/source/entities/patient-perio-exams';
import { PatientTransactionsSourceEntity } from './source/entities/patient-transactions';
import { PatientTreatmentSourceEntity } from '../exact/source/entities/patient-treatments';
import { StafferSourceEntity } from './source/entities/staff';
import { PracticeWorksUsedItemCodeConditionSourceEntity } from './source/entities/used-item-code-conditions';
import { PracticeWorksUsedItemCodeTreatmentSourceEntity } from './source/entities/used-item-code-treatments';
import { NoteItemCodeTreatmentSourceEntity } from '../exact/source/entities/note-item-code-treatments';
import { AppointmentRoomSourceEntity } from '../exact/source/entities/appointment-room';
import { ExactContactTranslator } from '../exact/sql-seeding-translators/contact';
import { PatientBPESourceEntity } from '../exact/source/entities/patient-bpe-scores';
import { UsedItemCodeTransactionSourceEntity } from './source/entities/used-item-code-transactions';
import { PatientRefundSourceEntity } from './source/entities/patient-refunds';
import { PatientLineItemsSourceEntity } from './source/entities/patient-line-items';
import { PatientDiscountSourceEntity } from './source/entities/patient-discounts';

export const PRACTICE_WORKS_SOURCE: ISource = {
  metadata: {
    name: 'Practice Works',
    version: 'v1',
  },
  configuration: [
    {
      name: 'Practice Id',
      description: 'Practice Works Practice Id',
      value: '',
    },
    {
      name: 'Database Name',
      description: 'Database Name',
      value: '',
    },
    {
      name: 'Database Username',
      description: 'Database Username',
      value: '',
    },
    {
      name: 'Database Password',
      description: 'Database Password',
      value: '',
    },
    {
      name: 'Database Connection Name',
      description:
        'Fully Qualified Name of Database. Eg. "practice-migrations:australia-southeast1:[instance_name]"',
      value: '',
    },
    {
      name: 'Source Bucket Storage Path',
      description: `Bucket storage path that patient files live under Eg. "gs://practice-name'`,
      value: '',
    },
  ],
};

export class PracticeWorksSourceHandler extends BaseSourceHandler {
  migrationType = 'Practice Works';
  migrationVersion = 'v1';
  source = PRACTICE_WORKS_SOURCE;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entityHandlers: ISourceEntityHandler<any>[] = [
    new StafferSourceEntity(),
    new PatientSourceEntity(),
    new ADAItemSourceEntity(),
    new ExactADASourceEntity(),
    new ContactsSourceEntity(),
    new AppointmentSourceEntity(),
    new PatientTreatmentSourceEntity(),
    new FeeScheduleSourceEntity(),
    new PatientNotesSourceEntity(),
    new PatientPerioExamsSourceEntity(),
    new PatientTransactionsSourceEntity(),
    new PatientBalanceSourceEntity(),
    new PatientDocumentsSourceEntity(),
    new PatientExternalLinksSourceEntity(),
    new AppointmentCategorySourceEntity(),
    new PracticeWorksUsedItemCodeConditionSourceEntity(),
    new PracticeWorksUsedItemCodeTreatmentSourceEntity(),
    new NoteItemCodeTreatmentSourceEntity(),
    new AppointmentRoomSourceEntity(),
    new PatientBPESourceEntity(),
    new UsedItemCodeTransactionSourceEntity(),
    new PatientRefundSourceEntity(),
    new PatientLineItemsSourceEntity(),
    new PatientDiscountSourceEntity(),
  ];

  sqlSeedingTranslators = [new ExactContactTranslator()];
}

export const PRACTICE_WORKS_REQUIRED_CSV_FILES = getRequiredCsvFilenames(
  new PracticeWorksSourceHandler().entityHandlers
);
